import { RouterProvider } from 'react-router-dom';
import browserRouter from './Components/Routes/BrowserRouter';

function App() {
  return (
    <RouterProvider router={browserRouter} />
  );
}

export default App;
